import { css, html, LitElement } from 'lit'
import { property } from 'lit/decorators.js'
import { safeCustomElement } from '@/utilities/custom-element'
import type { BadgeGroupSize } from './types'

@safeCustomElement('mdc-badge-group')
export class MdcBadgeGroup extends LitElement {
  @property({ type: String }) size: BadgeGroupSize = 'md'

  static styles = css`
		:host {
			display: block;
			font-family: var(--typography-font-family-sans);
		}

		.mdc-badge-group {
			display: flex;
			flex-wrap: wrap;
			align-items: flex-start;
			align-content: flex-start;
			gap: var(--spacing-050, 0.5rem);
		}
	`

  connectedCallback() {
    super.connectedCallback()
    this._updateChildSizes()
  }

  updated(changedProperties: Map<PropertyKey, unknown>) {
    super.updated(changedProperties)
    if (changedProperties.has('size')) {
      this._updateChildSizes()
    }
  }

  private _updateChildSizes() {
    const badges = this.querySelectorAll('mdc-badge')
    badges.forEach((badge) => {
      badge.setAttribute('size', this.size)
    })
  }

  render() {
    return html`
			<div class="mdc-badge-group">
				<slot></slot>
			</div>
		`
  }
}
